import React from "react"
import { CenterSelector } from "../../../components/orgComponents"

function RefundHome(){
    return <React.Fragment>
        <CenterSelector navigateTo='/refundDashboard'/>
    </React.Fragment>
}

export {RefundHome}